import type {
  TherapistPaginationSearchResponseDto,
  TherapistSearchResponseDto,
} from '@app/api';
import queryString from 'query-string';
import { URL_API } from '@/shared/urls';

export interface iGetWithFiltersResponse {
  therapists: Array<TherapistSearchResponseDto>;
  tab: string | null;
  total: number;
  count: number;
  page: number;
  totalPage: number;
  initialPage: number;
  currentUrl?: string;
  diseaseId?: string;
  diseaseName?: string;
  diseaseH1?: string;
  therapyMethodH1?: string | undefined;
  therapyMethodDescription?: string | undefined;
  therapyMethodTitle?: string | undefined;
  isB2B?: boolean,
}

export interface iTherapistFilter {
  tab?: string | null;
  page?: number;
  diseases?: string[];
  diseaseUrl?: string | undefined;
  firstname?: string | undefined;
  lastname?: string | undefined;
  isRecommendedTab?: boolean;
  isRecommendedTabUnauthorized?: boolean;
  childTherapists?: boolean;
  supervisorTherapists?: boolean;
  adultTherapists?: boolean;
}

export const MAX_THERAPISTS_IN_LIST = 15;

async function getWithFilters(
  query: iTherapistFilter,
): Promise<iGetWithFiltersResponse> {
  try {
    const params = queryString.stringify({
      ...query,
      limit: MAX_THERAPISTS_IN_LIST,
      page: query?.page || 1,
      diseases: query?.diseases || [],
    });

    const request = `${URL_API.getTherapistsWithFilter}?${params}`;
    const response = await fetch(request);
    const data: TherapistPaginationSearchResponseDto = await response.json();

    const result = {
      tab: query?.tab || null,
      therapists: data.data,
      total: data.total,
      count: data.count,
      page: query?.page || 1,
      totalPage: data.totalPage,
      initialPage: data.page,
      diseaseId: data?.diseaseId,
      diseaseName: data?.diseaseName,
      diseaseH1: data?.diseaseH1,
      therapyMethodH1: data?.therapyMethodH1,
      therapyMethodDescription: data?.therapyMethodDescription,
      therapyMethodTitle: data?.therapyMethodTitle,
    };

    return result;
  } catch (err) {
    const result = {
      tab: query?.tab || null,
      therapists: [],
      total: 0,
      count: 0,
      page: query?.page || 1,
      totalPage: 0,
      initialPage: 0,
    };

    return result;
  }
}

export default getWithFilters;
